import {useParams} from "react-router-dom";
import {Col, Container, Form, Row} from "react-bootstrap";
import {ENVIRONMENT_TYPE_PRODUCT, ENVIRONMENT_TYPE_SANDBOX, generateUrlLoginSf, SfGetTokenAction} from "../../common";
import {useEffect, useState} from "react";

export function LoginPage() {

    const {role}: any = useParams();

    useEffect(() => {
        if (!localStorage.getItem('access-token')) {
            localStorage.removeItem('environment-type');
        }
    }, [])

    const [sfEnvType, setSfEnvType] = useState(ENVIRONMENT_TYPE_PRODUCT);
    if (!SfGetTokenAction.includes(role)) {
        window.location.href = '/404'
    }

    if (localStorage.getItem('access-token')) {
        let userInfo = JSON.parse(localStorage.getItem('user-info') || '');
        if (userInfo.isSuperAdmin) {
            window.location.href = "/admin-console"
        } else {
            window.location.href = "/";
        }
    }

    async function handleSubmit() {
        const loginUrl = await generateUrlLoginSf(role, sfEnvType);
        window.location.href = loginUrl;
    }

    function changeSfEnvValue(e) {
        setSfEnvType(e.target.value)
        localStorage.setItem('environment-type', e.target.value);
    }

    const isAdmin = role === 'admin';

    return (
        <div className={isAdmin ? 'login-page admin-login-container' : 'login-page login-container'}>
            <Container className="login-body">
                <Row className="justify-content-center">
                    <Col md={8} lg={6} xs={12}>
                        <div className="login-title text-center">
                            <span className="login-badge">TeamSpirit Enterprise</span>
                            <h1 className="login-heading">打刻連携アドオン {isAdmin ? '管理者コンソール' : '管理コンソール'}</h1>
                            <h2 className="login-heading">ログイン</h2>
                        </div>

                        <div className="login-card">
                            <a onClick={handleSubmit} className="btn-login">
                                ログイン
                            </a>
                            {
                                !isAdmin &&
                                <div className="d-flex justify-content-center mt-3">
                                    <div className="login-radio">
                                        <Form.Check
                                            onChange={changeSfEnvValue}
                                            inline
                                            checked={sfEnvType == ENVIRONMENT_TYPE_PRODUCT}
                                            value={ENVIRONMENT_TYPE_PRODUCT}
                                            label={"本番環境"}
                                            name="sfEnvType"
                                            type={'radio'}
                                            id={`product`}
                                        />
                                    </div>
                                    <div className="login-radio">
                                        <Form.Check
                                            inline
                                            checked={sfEnvType == ENVIRONMENT_TYPE_SANDBOX}
                                            value={ENVIRONMENT_TYPE_SANDBOX}
                                            onChange={changeSfEnvValue}
                                            label={"Sandbox"}
                                            name="sfEnvType"
                                            type={'radio'}
                                            id={`sandbox`}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
